import * as React from "react";

// import * as styles from "./BlankLink.module.less";

export type PropsBlankLink = {
  href: string;
  children?: React.ReactNode | React.ReactNode[];
  title?: string;
  className?: string;
  download?: string;
  onMouseDown?: React.DOMAttributes<HTMLAnchorElement>["onMouseDown"];
};

export const BlankLink: React.FC<PropsBlankLink> = ({
  href,
  children,
  title,
  className,
  download,
  onMouseDown,
}) => (
  <a
    href={href}
    download={download}
    target="_blank"
    rel="noopener noreferrer"
    title={title}
    className={className}
    onClick={(e) => {
      e.stopPropagation();
    }}
    onMouseDown={onMouseDown}
  >
    {children}
  </a>
);
